import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { message } from "antd";
// import { useLazyQuery } from "@apollo/client";
import { checkToken } from "@util/token";
import { currentUser, getCookie, getQueryVariable, judge, setCookie } from "@util/utils";
import "./login_interceptor.less";
import LoginRegistModal from "../login_interceptor/login_regist_modal";
import ForgetPWDModal from "../login_interceptor/forgetPWD_modal";
import SetNewPWD from "../login_interceptor/setNewPWD_modal";
import Bindmobilenumber from "../login_interceptor/bindPhone_modal";
import OtherLogin from "../login_interceptor/otherLogin_modal";
// import { have_me_team } from "@api/team";
import brightlogo from "@assets/images/bright-logo.png";
import { doRelativeLogin, queryWxCallbackUrl, queryWxCode } from "@api/login";
import zclogo from "@assets/images/zc_logo.png";
import loginContext from "@components/login_context";
import classnames from "classnames";
import { ym_url } from "@util/enum";
import { saveLoginModalWechatReturnContext } from "@components/login_modal/wechatReturn";

export default function LoginInterceptor({
  children,
  showVisible,
  onVisible = () => {},
  onWechatLoginVisible = () => {},
  isShop,
  shopPlatFun,
}) {
  const { t } = useTranslation();
  const url = new URL(location.href);

  const show = url.searchParams.get("show_login");
  const deferLoginRedirect = url.searchParams.get("deferLoginRedirect") === "1";
  const callback = getQueryVariable('callback');
  const [visible, setVisible] = useState(false);
  // const [pwdLogin, setPwdLogin] = useState(false);

  const [pwdLogin, setPwdLogin] = useState(show);
  const [forgetPWDVisible, setForgetPWDVisible] = useState(false);
  const [newPWDVisible, setNewPWDVisible] = useState(false);
  const [bindPhoneVisible, setBindPhoneVisible] = useState(false);
  const [otherLoginVisible, setOtherLoginVisible] = useState(false);
  const [loginName, setLoginName] = useState("");
  const [newUcode, setNewUcode] = useState({});
  const [direct, serDirect] = useState("");

  const {
    getUrl,
    getUrlByHadParam,
    identityType,
    isPhone,
    isPhoneWx,
    platform,
    privateMemberOpen,
    privateMemberTeamId,
    privateMemberInviterId,
    privateMemberSource,
    privateTeamLogo,
  } = useContext(loginContext);
  const showPrivateTeamLogo = isPhone && privateMemberOpen && privateTeamLogo;
  const loginLogoSrc = showPrivateTeamLogo
    ? privateTeamLogo
    : identityType === 2
      ? zclogo
      : brightlogo;
  const hasSubModalVisible =
    forgetPWDVisible || newPWDVisible || bindPhoneVisible || otherLoginVisible;
  // 微信扫码那一屏（PC 那张卡片）跟随「呈现」判定：PC 与 pad 都按 PC 呈现、共用同一张卡片，
  // 只有手机端不渲染这张卡片（手机端仍是原来的那套）。
  // 注意：登录链路（isPhoneWx / privateMemberWxLoginParams）保持原样，平板仍按非 PC 走。
  const wechatLoginVisible = !isPhone && otherLoginVisible && loginName === "微信登录";

  useEffect(() => {
    onWechatLoginVisible(wechatLoginVisible);
  }, [onWechatLoginVisible, wechatLoginVisible]);

  const openWechatLogin = (e) => {
    e?.stopPropagation();
    const inviterId = privateMemberInviterId ? Number(privateMemberInviterId) : null;
    const hasInviterId = inviterId !== null && !Number.isNaN(inviterId) && inviterId > 0;
    const privateMemberWxLoginParams =
      isPhoneWx && privateMemberOpen && privateMemberTeamId
        ? {
          teamId: privateMemberTeamId,
          ...(hasInviterId ? { inviterId } : {}),
          ...(privateMemberSource ? { source: privateMemberSource } : {}),
        }
        : {};
    const appendPrivateMemberWxLoginParams = (params = {}) => ({
      ...params,
      ...privateMemberWxLoginParams,
    });
    const buildWxWebLoginUrl = (origin, key) => {
      const params = new URLSearchParams({
        key: key || "",
        platform,
      });
      Object.entries(privateMemberWxLoginParams).forEach(([name, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(name, value);
        }
      });
      return `${origin}/api/wx/webLogin?${params.toString()}`;
    };
    const clearLoginRelatedStorage = () => {
      if (localStorage.getItem("collectType")) {
        localStorage.removeItem("collectId");
        localStorage.removeItem("collectType");
      }
      if (localStorage.getItem("brandId")) {
        localStorage.removeItem("collectId");
        localStorage.removeItem("brandId");
      }
      if (localStorage.getItem("entrust")) {
        localStorage.removeItem("collectId");
        localStorage.removeItem("entrust");
      }
    };
    const wxauthLogin = () => {
      let url = window.location.origin;
      const host = window.location.host;
      let appid = 'wx80dfb3bc1c99533b';
      if (url.indexOf(":3001") >= 0 || url.indexOf("ngtest.guyubao.com") >= 0) {
        url = `https://${ym_url.test}`;
      }
      if (host.indexOf('material-pre') >= 0) {
        appid = 'wx26852148b145376b';
      } else if (window.location.origin.indexOf('material-test') < 0) {
        appid = 'wx54e4bc4ffda6e5f1';
      }
      let srt = '';
      const { key, val, url: openUrl } = getUrlByHadParam(1, true);
      if (openUrl) {
        srt = openUrl;
        localStorage.setItem(key, val);
        if (key === 'clientId') localStorage.setItem('entrust', val);
      }
      clearLoginRelatedStorage();
      if (srt) {
        queryWxCallbackUrl({ redirectUrl: srt }).then((res) => {
          if (res.success) {
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
              buildWxWebLoginUrl(url, res.result)
            )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
          }
        });
        return;
      }
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
        buildWxWebLoginUrl(url, srt)
      )}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    };
    const queryWechatCode = () => {
      const { key, val, url } = getUrlByHadParam(1, true);
      const ym = window.location.origin;
      const privateMemberReturnUrl =
        url || `${window.location.pathname}${window.location.search}${window.location.hash}`;
      const shouldUseWxSucCallback = Boolean(privateMemberWxLoginParams.teamId);
      if (shouldUseWxSucCallback) {
        saveLoginModalWechatReturnContext({
          returnUrl: privateMemberReturnUrl,
          shouldJoin: true,
          ...privateMemberWxLoginParams,
        });
      }
      let callback = "";
      if (url) {
        callback = ym + url;
        localStorage.setItem(key, val);
        if (key === 'clientId') localStorage.setItem('entrust', val);
      }
      const callbackTarget = shouldUseWxSucCallback
        ? `${window.location.origin}/wx_suc.html?fromLoginModal=1`
        : callback;
      const openWechatQr = (res) => {
        if (res.success) {
          setCookie('platform', platform, 90);
          clearLoginRelatedStorage();
          setForgetPWDVisible(false);
          setNewPWDVisible(false);
          setLoginName("微信登录");
          setVisible(false);
          setOtherLoginVisible(true);
          serDirect(res.result?.split("redirect:")[1]);
        } else {
          message.error(t(res.errorInfo));
        }
      };
      if (callbackTarget) {
        queryWxCallbackUrl({ redirectUrl: callbackTarget }).then((res) => {
          if (res.success) {
            queryWxCode(appendPrivateMemberWxLoginParams({ platform, callback: res.result })).then(openWechatQr);
          } else {
            message.error(t(res.errorInfo));
          }
        });
        return;
      }
      queryWxCode(appendPrivateMemberWxLoginParams({ platform, callback: callbackTarget })).then(openWechatQr);
    };

    if (judge()) {
      if (privateMemberWxLoginParams.teamId) {
        const { url } = getUrlByHadParam(1, true);
        saveLoginModalWechatReturnContext({
          returnUrl:
            url ||
            `${window.location.pathname}${window.location.search}${window.location.hash}`,
          shouldJoin: true,
          ...privateMemberWxLoginParams,
        });
      }
      wxauthLogin();
      return;
    }
    queryWechatCode();
  };
  const openWechatLoginFromSubModal = (e) => {
    e?.stopPropagation();
    openWechatLogin(e);
  };

  const checkLogin = ()=>{
    if (deferLoginRedirect) return;
    if(isShop){
      sessionStorage.setItem('shop_callback',callback);
    }
    const token = getCookie('mtoken');
    if (token && location.href.indexOf("/login.html?show_login") === -1) {
      if(!isShop){
        const user = currentUser();
        if (!user?.id||user?.id==0) {
      window.addEventListener('userChange',checkLogin)
      return 
    }
        getUrl();
      }else{ // 已登录
        getShopToken(token);
      }
    }
  }

  useEffect(()=>{
    checkLogin()
    return ()=>{
      window.removeEventListener('userChange',checkLogin)
    }
  },[])

  // 获取商城token
  const getShopToken = (token)=>{
    doRelativeLogin({token,source:'MATERIAL',platform:'MATERIAL_MALL_H5'}).then(res=>{
      if(res.token){
        shopPlatFun(res.token);
      }
    })
  }
  //没有上次登录记录时，
  // const getUrl = () => {
  //   if(identityType) {
  //     window.location.href = `/material_square.html`;
  //     return
  //   }
  //   have_me_team().then((res) => {
  //     const myTeamData = res?.result;
  //     let newTeam = null;
  //     if (myTeamData?.myCreated?.length) {
  //       myTeamData?.myCreated.forEach((item) => {
  //         if (!newTeam) {
  //           newTeam = { ...item };
  //         } else if (item.tmCreate > newTeam?.tmCreate) {
  //           newTeam = { ...item };
  //         }
  //       });
  //     }
  //     if (myTeamData?.myJoin?.length) {
  //       myTeamData?.myJoin.forEach((item) => {
  //         if (!newTeam) {
  //           newTeam = { ...item };
  //         } else if (item.tmCreate > newTeam?.tmCreate) {
  //           newTeam = { ...item };
  //         }
  //       });
  //     }
  //     if (newTeam) {
  //       window.location.href = `/team_home.html?clientId=${newTeam.id}&clientType=2`;
  //       return;
  //     }
  //     const user = currentUser();
  //     //不是供应商
  //     if (
  //       !user?.client ||
  //       user?.client?.checkStatus * 1 === 2 ||
  //       user?.client?.checkStatus * 1 === 0
  //     ) {
  //       //跳到个人首页
  //       window.location.href = `/user_home.html`;
  //     } else {
  //       //跳到供应商首页
  //       window.location.href = `/supplier.html/#/product_collection`;
  //     }
  //   });
  // };
  useEffect(() => {
    setVisible(show);
  }, [show]);

  useEffect(() => {
    setVisible(showVisible);
  }, [showVisible]);

  useEffect(() => {
    if (!visible) {
      onVisible();
    }
  }, [visible]);

  return (
    <div
      className={classnames({
        "login-interceptor-wechat": wechatLoginVisible,
      })}
      onClick={(e) => {
        if (hasSubModalVisible) {
          return;
        }
        const result = checkToken();
        if (!result) {
          e.preventDefault();
          setVisible(true);
        }
      }}
    >
      {children}
      {/* 开始注册登录 */}
      
      
      {visible && (
        <div className="boxShow">
          <LoginRegistModal
            visible={visible}
            setVisible={setVisible}
            setForgetPWDVisible={setForgetPWDVisible}
            setOtherLoginVisible={setOtherLoginVisible}
            loginName={loginName}
            setLoginName={setLoginName}
            pwdLogin={pwdLogin}
            setPwdLogin={setPwdLogin}
            serDirect={serDirect}
            isShop={isShop}
            shopPlatFun={shopPlatFun}
        />
      </div>)}
      {/* 忘记密码 */}
      {forgetPWDVisible && (
        <div
          className="boxShow"
          onClick={(e) => {
            e.stopPropagation();
            setVisible(false);
          }}
        >
          <ForgetPWDModal
            setForgetPWDVisible={setForgetPWDVisible}
            setNewPWDVisible={setNewPWDVisible}
            setNewUcode={setNewUcode}
            setVisible={setVisible}
            onWechatLogin={openWechatLoginFromSubModal}
          ></ForgetPWDModal>
      </div>)}
      {newPWDVisible && (
        <div
          className="boxShow"
          onClick={(e) => {
            e.stopPropagation();
            setVisible(false);
          }}
        >
          <SetNewPWD
            setNewPWDVisible={setNewPWDVisible}
            setForgetPWDVisible={setForgetPWDVisible}
            newUcode={newUcode}
            setVisible={setVisible}
            onWechatLogin={openWechatLoginFromSubModal}
          ></SetNewPWD>
        </div>
      )}
      {bindPhoneVisible && (
        <div
          className="boxShow"
          onClick={(e) => {
            e.stopPropagation();
            setVisible(false);
          }}
        >
          <Bindmobilenumber
            setBindPhoneVisible={setBindPhoneVisible}
            isShop={isShop}
            shopPlatFun={shopPlatFun}
            identityType={identityType}
          ></Bindmobilenumber>
        </div>
      )}
      {otherLoginVisible && (
        <div
          className="boxShow"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <OtherLogin
            setVisible={setVisible}
            setOtherLoginVisible={setOtherLoginVisible}
            loginName={loginName}
            setLoginName={setLoginName}
            setPwdLogin={setPwdLogin}
            serDirect={serDirect}
            direct={direct}
            isShop={isShop}
            shopPlatFun={shopPlatFun}
          ></OtherLogin>
        </div>
      )}
      <div className={classnames("login-logo", "bjweb-flex-center",{
        "login-logo-phone": isPhone,
        "login-logo-private": showPrivateTeamLogo,
      })}>
          {/* <img src="https://oss-panzi-app-prod.panzitech.com/_3793_1664261115898_200x73_111.png"/> */}
          <img
            src={loginLogoSrc}
            style={!showPrivateTeamLogo && identityType === 2 ? { width: 105, opacity: 0.85, marginTop: -20 } : {}}
          />
      </div>
    </div>
  );
}
